import React from 'react';
import { FinancialAmount, DocumentReference } from './FinancialAmount';
import { StatusBadge } from './StatusBadge';

export function AccountCode({ children, className = '', ...props }) {
  return <DocumentReference dir="ltr" className={`font-mono [unicode-bidi:isolate] ${className}`} {...props}>{children || '—'}</DocumentReference>;
}

export function JournalEntryReference({ children, className = '', ...props }) {
  return <DocumentReference dir="ltr" className={`font-mono font-semibold [unicode-bidi:isolate] ${className}`} {...props}>{children || '—'}</DocumentReference>;
}

export function BankAccountReference({ children, className = '', ...props }) {
  return <DocumentReference dir="ltr" className={`font-mono [unicode-bidi:isolate] ${className}`} {...props}>{children || '—'}</DocumentReference>;
}

export function IBANDisplay({ children, className = '', ...props }) {
  return <DocumentReference dir="ltr" className={`font-mono tracking-wide [unicode-bidi:isolate] ${className}`} {...props}>{children || '—'}</DocumentReference>;
}

export function DebitCreditAmount({ value, currency = 'AED', kind = 'debit', className = '', ...props }) {
  const label = kind === 'credit' ? 'دائن' : 'مدين';
  const tone = kind === 'credit' ? 'border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-500/30 dark:bg-sky-500/10 dark:text-sky-200' : 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-500/30 dark:bg-blue-500/10 dark:text-blue-200';
  return (
    <span className={`inline-flex min-w-[8rem] items-center justify-between gap-2 rounded-md border px-2 py-1 text-xs ${tone} ${className}`} {...props}>
      <span className="font-semibold">{label}</span>
      <FinancialAmount value={value} currency={currency} className="font-mono tabular-nums" />
    </span>
  );
}

export function PostingStatusBadge({ status, className = '', ...props }) {
  const labels = { draft: 'مسودة', unposted: 'غير مرحّل', posted: 'مُرحّل', reversed: 'معكوس', cancelled: 'ملغي' };
  return <StatusBadge status={status} label={labels[status] || status || 'غير معروف'} className={className} {...props} />;
}

export function ReconciliationStatusBadge({ status, className = '', ...props }) {
  const labels = { draft: 'مسودة', completed: 'مغلقة', reconciled: 'مطابقة', partially_reconciled: 'مطابقة جزئية', unmatched: 'غير مطابق', matched: 'مطابق', pending: 'معلّق', failed: 'فشل' };
  return <StatusBadge status={status} label={labels[status] || status || 'غير معروف'} className={className} {...props} />;
}

export function FiscalPeriodBadge({ status, className = '', ...props }) {
  const labels = { open: 'مفتوحة', closing: 'قيد الإغلاق', closed: 'مغلقة', locked: 'مقفلة' };
  return <StatusBadge status={status} label={labels[status] || status || 'غير معروف'} className={className} {...props} />;
}

export function AccountingTableShell({ children, className = '', ...props }) {
  return <div className={`overflow-x-auto rounded-xl border border-border bg-card shadow-sm ${className}`} {...props}>{children}</div>;
}

export function FinancialReportHeader({ title, subtitle, children }) {
  return <header className="mb-4 border-b border-border pb-3"><h2 className="text-xl font-bold text-foreground">{title}</h2>{subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}{children}</header>;
}

export function ReportSectionRow({ children, level = 0, total = false, className = '', ...props }) {
  return <tr className={`${total ? 'bg-muted/60 font-bold' : 'hover:bg-muted/40'} ${className}`} data-level={level} {...props}>{children}</tr>;
}
